import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Favourite } from '../models/favourite';

// Define a type for the slice state
interface FavouritesState {
  mostFavourites: Favourite[];
  userFavourites: Favourite[];
  isLoading: boolean;
  error: string | null;
  hasLoadedMostFavourites: boolean;
  hasLoadedUserFavourites: boolean;
}

// Define the initial state using that type
const initialState: FavouritesState = {
  mostFavourites: [],
  userFavourites: [],
  isLoading: false,
  error: null,
  hasLoadedMostFavourites: false,
  hasLoadedUserFavourites: false,
};

export const favouritesSlice = createSlice({
  name: 'favourites',
  initialState,
  reducers: {
    setMostFavourites: (state, action: PayloadAction<Favourite[]>) => {
      state.mostFavourites = action.payload;
      state.hasLoadedMostFavourites = true;
    },
    setUserFavourites: (state, action: PayloadAction<Favourite[]>) => {
      state.userFavourites = action.payload;
      state.hasLoadedUserFavourites = true;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    addFavourite: (state, action: PayloadAction<Favourite>) => {
      state.userFavourites.push(action.payload);
    },
    removeFavourite: (state, action: PayloadAction<number>) => {
      state.userFavourites = state.userFavourites.filter(fav => fav.id !== action.payload);
    },
    clearFavourites: (state) => {
      state.mostFavourites = [];
      state.userFavourites = [];
      state.hasLoadedMostFavourites = false;
      state.hasLoadedUserFavourites = false;
      state.error = null;
    },
  },
});

export const {
  setMostFavourites,
  setUserFavourites,
  setLoading,
  setError,
  addFavourite,
  removeFavourite,
  clearFavourites,
} = favouritesSlice.actions;

export default favouritesSlice.reducer;
